<template>
  <div
    class="absolute top-full mt-2 left-0 w-full bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden z-50"
  >
    <div v-if="loading" class="flex flex-col">
      <div v-for="i in 3" :key="i" class="flex items-center gap-3 px-4 py-3 border-b border-gray-50 last:border-0">
        <Skeleton width="2rem" height="2rem" border-radius="0.5rem" />
        <div class="flex flex-col gap-1.5 flex-1 min-w-0">
          <Skeleton width="60%" height="0.75rem" />
          <Skeleton width="35%" height="0.625rem" />
        </div>
        <Skeleton width="3.5rem" height="1.25rem" border-radius="9999px" />
      </div>
    </div>

    <template v-else>
      <ul v-if="results.length">
        <li
          v-for="part in results"
          :key="part.id"
          class="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 cursor-pointer transition-colors border-b border-gray-50 last:border-0"
          @mousedown.prevent="emit('selectProduct', part)"
        >
          <div class="w-8 h-8 rounded-lg bg-[#f0fbfd] flex items-center justify-center flex-shrink-0">
            <i class="pi pi-box text-[#2db9d6] text-xs"></i>
          </div>
          <div class="flex flex-col min-w-0">
            <span class="font-mono font-semibold text-sm text-[#1a233f] truncate">{{ part.partNumber }}</span>
            <span v-if="part.manufacturer" class="text-xs text-gray-400 truncate">{{ part.manufacturer.name }}</span>
          </div>
          <AvailabilityBadge :quantity="part.quantity" size="small" class="ml-auto flex-shrink-0" />
        </li>
      </ul>

      <div v-else-if="query.length >= minLength" class="flex items-center gap-2 px-4 py-3 text-sm text-gray-400">
        <i class="pi pi-search text-gray-300"></i>
        {{ t('header.noResults') }}
      </div>

      <div
        class="flex items-center gap-3 px-4 py-3 hover:bg-[#f0fbfd] cursor-pointer transition-colors border-t border-gray-100"
        @mousedown.prevent="emit('selectEnquiry')"
      >
        <div class="w-8 h-8 rounded-lg bg-[#041E42] flex items-center justify-center flex-shrink-0">
          <i class="pi pi-send text-white text-xs"></i>
        </div>
        <div class="flex flex-col">
          <span class="text-sm font-semibold text-[#1a233f]">{{ t('header.enquiryLink') }}</span>
          <span class="text-xs text-gray-400">{{ query || t('header.enquiryLinkSub') }}</span>
        </div>
        <i class="pi pi-arrow-right ml-auto text-gray-300 text-xs"></i>
      </div>
    </template>
  </div>
</template>

<script setup>
import { Skeleton } from 'primevue'
import { useI18n } from 'vue-i18n'
import AvailabilityBadge from '@/components/general/ui/AvailabilityBadge.vue'

defineProps({
  results: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  query: { type: String, default: '' },
  minLength: { type: Number, default: 2 },
})

const emit = defineEmits(['selectProduct', 'selectEnquiry'])
const { t } = useI18n({ useScope: 'global' })
</script>
